<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1">FIRST</h1>
<p class="noind" style="margin-top:20px;">“Just the place for a Snark!” the Bellman cried,</p>
<p class="ind">As he landed his crew with care;</p>
<p class="noind">Supporting each one on the top of the tide,</p>
<p class="ind">By a finger entwined in his hair.</p>
<p class="noind" style="margin-top:20px;">“Just the place for a Snark! I have said it twice: </p>
<p class="ind">That alone should encourage the crew.</p>
<p class="noind">Just the place for a Snark! I have said it thrice: </p>
<p class="ind">What I tell you three times is true.”</p>
<p class="epi" style="margin-top:20px;"><i>—The Hunting of the Snark</i></p>
<p class="epi2">Fit the First</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6chap1.vue?42dfd2da